import React from 'react';
import BadgeProfile from '../badges/BadgeProfile.jsx';

export default function CardClient(props){
	const { 
		client,
		details = false,
		backgroundColor = 'white'
	} = props;

	const cardClasses = 'card border-none bg-' + backgroundColor + ' text-gc-dark-blue p-3 h-100';

	if (details) {
		return (
			<div className={cardClasses}>
				<div className="d-flex align-items-center my-auto">
					<div className="mr-2">
						<i className="fa-regular fa-user-tag h5"></i>
					</div>
					<div style={{maxWidth: '80%'}}>
						<span className="d-block h6 font-weight-bold m-0">
							{(client.surname + ' ' + client.name).truncate(20)}

							{client.business_introducer == 1 && 
								<span className="ml-2">
									<BadgeProfile 
										profile={''}
										retrocession={Number(client?.retrocession).toFixed(2) + '%'}
										tooltip={true} 
										tooltipText={'business_introducer'.trad()}
									/>
								</span>
							}
						</span>
						{client.phone && <span className="d-block small font-weight-normal" style={{lineHeight: '1rem'}}>{client.phone}</span>}
						{
							client.email && (client.email_has_error ?
							<span className="d-block small font-weight-normal badge badge-danger mt-1" style={{lineHeight: '1rem'}}>{'email_error'.trad()}</span>
							:
							<span className="d-block small text-truncate font-weight-normal" style={{lineHeight: '1rem'}}>{client.email}</span>)
						}
					</div>
				</div>
			</div>
		)
	}
	else{
		return (
			<div className={cardClasses}>
				<div className="d-flex align-items-center m-auto">
					<div className="">
						<i className="fa-regular fa-user-tag h5"></i>
					</div>
					<div className="position-relative ml-2 card-btn-text">
						<span 
							className="d-block h6 font-weight-bold m-0" 
							style={{lineHeight: '1rem'}}
						>
							{(client.client_display_name ?? (client.surname + ' ' + client.name)).truncate(15)}
						</span>
					</div>
				</div>
				{client.business_introducer == 1 && 
					<span className="position-absolute" style={{top: '4px', right: '5px'}}>
						<BadgeProfile 
							profile={''} 
							retrocession={Number(client?.retrocession).toFixed(2) + '%'}
							tooltip={true} 
							tooltipText={'business_introducer'.trad()}
						/>
					</span>
				}
			</div>
		)
	}
}